export var InspectionGroupHeaderTypes;
(function (InspectionGroupHeaderTypes) {
    InspectionGroupHeaderTypes["COLLECTION"] = "collection";
    InspectionGroupHeaderTypes["INSPECTION_TYPE"] = "inspectionType";
    InspectionGroupHeaderTypes["ISSUES_TO_FIX"] = "issuesToFix";
    InspectionGroupHeaderTypes["PREVIOUS_INSPECTION_DATE"] = "previousInspectionDate";
    InspectionGroupHeaderTypes["NEXT_INSPECTION_DATE"] = "nextInspectionDate";
    InspectionGroupHeaderTypes["NEXT_STATUS"] = "nextStatus";
    InspectionGroupHeaderTypes["PREVIOUS_STATUS"] = "previousStatus";
    InspectionGroupHeaderTypes["INSPECTION_STATUSES"] = "inspectionStatuses";
    InspectionGroupHeaderTypes["RESPONSIBLE"] = "responsible";
})(InspectionGroupHeaderTypes || (InspectionGroupHeaderTypes = {}));
export var STATUS_BAR_DONE = "Done";
//# sourceMappingURL=InspectionGroupHeaderTypes.js.map